import truncate from "lodash-es/truncate"

import { Obj, extractText, urlFor } from "scrivito"
import { isImage } from "scrivito/Objs/Image/ImageObjClass"
import { ensureString } from "shared/lib/ensureString"

export function getMetadata(page: Obj, siteName?: string) {
  // if (isDropdown(page)) return [{ name: "robots", content: "noindex" }]

  const meta = [
    { name: "twitter:card", content: "summary_large_image" },
    { property: "og:type", content: "article" },
    { property: "og:url", content: urlFor(page) }
  ]

  if (siteName) {
    meta.push({ property: "og:site_name", content: siteName })
  }

  if (!page.get("robotsIndex")) {
    meta.push({ name: "robots", content: "noindex" })
  }

  const extractedText = extractText(page, { length: 330 })
  const description = ensureString(page.get("description") || extractedText)
  if (description) {
    meta.push({ name: "description", content: description })
  }

  const keywords = ensureString(page.get("keywords"))
  if (keywords) {
    meta.push({ name: "keywords", content: keywords })
  }

  const root = Obj.root()
  if (root) {
    const siteFacebookAppId = ensureString(root.get("siteFacebookAppId"))
    if (siteFacebookAppId) {
      meta.push({ property: "fb:app_id", content: siteFacebookAppId })
    }

    const siteTwitterSite = ensureString(root.get("siteTwitterSite"))
    if (siteTwitterSite) {
      meta.push({ name: "twitter:site", content: siteTwitterSite })
    }
  }

  const tcCreator = ensureString(page.get("tcCreator"))
  if (tcCreator) {
    meta.push({ name: "twitter:creator", content: tcCreator })
  }

  const tcDescription = ensureString(
    page.get("tcDescription") ||
      truncate(extractedText, { length: 137, separator: /,? +/ })
  )
  if (tcDescription) {
    meta.push({ name: "twitter:description", content: tcDescription })
  }

  const tcImage = imageUrlFor(page.get("tcImage"))

  if (tcImage) meta.push({ name: "twitter:image", content: tcImage })

  const tcTitle = ensureString(page.get("tcTitle") || page.get("title"))
  if (tcTitle) meta.push({ name: "twitter:title", content: tcTitle })

  const ogDescription = ensureString(
    page.get("ogDescription") ||
      truncate(extractedText, { length: 297, separator: /,? +/ })
  )
  if (ogDescription) {
    meta.push({ property: "og:description", content: ogDescription })
  }

  const ogImage = imageUrlFor(page.get("ogImage"))

  if (ogImage) meta.push({ property: "og:image", content: ogImage })

  const ogTitle = ensureString(page.get("ogTitle") || page.get("title"))
  if (ogTitle) meta.push({ property: "og:title", content: ogTitle })

  return meta
}

function imageUrlFor(obj: unknown) {
  if (isImage(obj) && obj.get("blob")) return obj.contentUrl()
  return undefined
}
